import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
//custom imports
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import AllTransaction from "./AllTransaction";
//import Actions from "./components/Actions";
//import TabPanel from "./components/Tab"
function AllTransactions() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <br />
      <MDBox borderRadius="lg" coloredShadow="info" py={0.01}>
            <AllTransaction/>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
export default AllTransactions;
